<template>
  <v-dialog max-width="500" transition="top" persistent v-model="dialogActive">
    <template v-slot:activator="{ props: activatorProps }">
      <slot name="activator" v-bind="activatorProps">
        <v-btn v-bind="activatorProps" variant="text" block>
          <v-icon start> mdi-plus-circle-outline </v-icon>
          {{ $t('workspaces.buttons.createWorkspace') }}
        </v-btn>
      </slot>
    </template>

    <template #default>
      <v-card>
        <v-card-item class="px-4">
          <v-card-title> {{ $t('workspaces.text.createAWorkspace') }}</v-card-title>
          <v-card-subtitle>
            {{ $t('workspaces.text.createAWorkspaceDescription') }}
          </v-card-subtitle>
        </v-card-item>
        <v-card-subtitle class="">
          {{ $t('workspaces.text.workspaceName') }}
        </v-card-subtitle>
        <v-card-text class="px-4 pb-0">
          <v-text-field
            v-model="editedWorkspace.name"
            :placeholder="$t('workspaces.placeholders.nameField')"
            :rules="[v => !!v || $t('workspaces.validation.nameField')]"
            required
            variant="outlined"
          >
          </v-text-field>
        </v-card-text>
        <v-card-subtitle>
          {{ $t('workspaces.text.workspaceDescription') }}
        </v-card-subtitle>
        <v-card-text class="px-4 pb-0">
          <v-textarea
            v-model="editedWorkspace.description"
            :placeholder="$t('workspaces.placeholders.descriptionField')"
            required
            variant="outlined"
          >
          </v-textarea>
        </v-card-text>
        <v-card-subtitle>
          {{ $t('workspaces.text.shareWorkspace') }}
        </v-card-subtitle>
        <v-card-text class="px-0">
          <user-list
            v-if="editedWorkspace.shared_users.length > 0"
            key="user-list"
            :user-ids="editedWorkspace.shared_users"
            @user-close-clicked="removeWorkspaceUser"
            :show-actions="['remove']"
          />
          <workspace-user-share-list
            key="workspace-user-share-list"
            :workspace="editedWorkspace"
            :updating-workspace="false"
            @add-workspace-user="addWorkspaceUser"
            v-model="childMenu"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :text="$t(`basicActions.cancel`)" @click="dialogActive = false" />
          <v-btn :text="$t(`basicActions.create`)" :disabled="!allowSubmit" @click="onSubmit" />
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import BasicTooltip from '@/components/tooltips/BasicTooltip.vue'
import { useWorkspaceSchemas } from '@/schemas/UseWorkspaceSchemas'
import { useFirestoreWorkspaces } from '@/composables/workspaces/useFirestoreWorkspaces'
import WorkspaceUserShareList from '@/components/workspaces/WorkspaceUserShareList.vue'
import UserList from '@/components/users/UserList.vue'

import { log } from '@/plugins/logger'
export default {
  name: 'CreateWorkspaceDialog',
  setup() {
    const { getWorkspaceSchema } = useWorkspaceSchemas()
    const { createWorkspace } = useFirestoreWorkspaces()
    return {
      getWorkspaceSchema,
      createWorkspace
    }
  },
  components: {
    BasicTooltip,
    WorkspaceUserShareList,
    UserList
  },
  data() {
    return {
      dialogActive: false,
      editedWorkspace: {},
      childMenu: false
    }
  },
  watch: {
    dialogActive(val) {
      if (!val) {
        setTimeout(() => {
          this.clearEditedWorkspace() // timeout to avoid UI flicker
        }, 500)
      }
    }
  },
  computed: {
    allowSubmit() {
      return this.editedWorkspace.name && this.editedWorkspace.name.length > 0
    }
  },
  methods: {
    clearEditedWorkspace() {
      this.editedWorkspace = this.getWorkspaceSchema()
    },

    async onSubmit() {
      let createdWorkspace = await this.createWorkspace(this.editedWorkspace)
      if (createdWorkspace) {
        this.dialogActive = false
        this.$emit('workspace-created', createdWorkspace)
      }
    },

    addWorkspaceUser(userId) {
      this.editedWorkspace.shared_users.push(userId)
    },
    removeWorkspaceUser(userId) {
      this.editedWorkspace.shared_users = this.editedWorkspace.shared_users.filter(
        id => id !== userId
      )
    }
  },
  mounted() {
    this.editedWorkspace = this.getWorkspaceSchema()
  }
}
</script>
